import { VossProductGroupType } from "../../Constants/VOSS/vossProductGroupType";
import { InfoLabel } from "../Badges/InfoLabel";
import Card from "../Card/Card";

const type = {
    [VossProductGroupType.Included]: { label: "Included", type: "success" },
    [VossProductGroupType.Optional]: { label: "Optional", type: "info" },
}

export function ProductGroupCard({ productGroup, children }) {
    return (
        <Card>
            <Card.Header>
                <div className="d-flex align-items-center justify-content-between w-100">
                    <Card.Header.Title>{productGroup.name}</Card.Header.Title>
                    <div className="mb-16">
                        <InfoLabel
                            type={type[productGroup.productGroupType].type}
                            title={type[productGroup.productGroupType].label}
                        />
                    </div>
                </div>
            </Card.Header>
            <Card.Content>
                {children}
            </Card.Content>
        </Card>
    );
}